import { render } from "./UploadGoods.vue?vue&type=template&id=52a74d24&scoped=true"
import script from "./UploadGoods.vue?vue&type=script&lang=js"
export * from "./UploadGoods.vue?vue&type=script&lang=js"

import "./UploadGoods.vue?vue&type=style&index=0&id=52a74d24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a74d24"]])

export default __exports__